export const data = [
    {
      id: 1,
      content: "Early Educational Software",
      start: "1980-01-01",
      end: "1989-12-31",
      title: "The Beginning of EdTech - Introduction of educational software and computer-based learning in schools.",
      className: "edtech-item"
    },
    {
      id: 2,
      content: "Internet in Education",
      start: "1990-01-01",
      end: "1999-12-31",
      title: "The Web Era Begins - Internet connectivity reaches schools, enabling online research and communication.",
      className: "edtech-item"
    },
    {
      id: 3,
      content: "Learning Management Systems",
      start: "2000-01-01",
      end: "2009-12-31",
      title: "Digital Classrooms - LMS platforms like Blackboard and Moodle revolutionize course management.",
      className: "edtech-item"
    },
    {
      id: 4,
      content: "MOOCs & Mobile Learning",
      start: "2010-01-01",
      end: "2019-12-31",
      title: "Education Goes Mobile - Massive Open Online Courses and mobile apps make education accessible everywhere.",
      className: "edtech-item"
    },
    {
      id: 5,
      content: "AI & Personalized Learning",
      start: "2020-01-01",
      end: "2025-12-31",
      title: "The Future of EdTech - Artificial intelligence enables personalized learning experiences and adaptive education.",
      className: "edtech-item"
    },
];